import { defineComponent as _defineComponent } from 'vue'
import { Modal, SingleInput, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { computed, ref } from 'vue';

interface Props {
  isOpen: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'save-portfolio-name', portfolioName: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioNameModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "save-portfolio-name"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'save-portfolio-name', portfolioName: string): void;
}), expose: any, slots: any, attrs: any }) {





const portfolioName = ref('');

const isDisabled = computed(() => {
  return portfolioName.value === '';
});

function clear() {
  portfolioName.value = '';
}

function handleChange(value: string) {
  if (value.trim() === '') {
    portfolioName.value = value.trim();
    return;
  }

  portfolioName.value = value;
}

function emitSavePortfolioName() {
  emit('save-portfolio-name', portfolioName.value);
}

function emitClose() {
  emit('close');
}

return { __sfc: true,emit, portfolioName, isDisabled, clear, handleChange, emitSavePortfolioName, emitClose, Modal, SingleInput, ButtonPrimary }
}

})